import {ADD_APPROVAL, DELETE_APPROVAL} from '../../../actions/actiontypes';

export default (state, action) => {
	const targetDocumentId = action?.meta?.api?.data?.documentId;
	let targetApprovalId = action?.meta?.api?.data?.approvalId;
	if (action?.type === ADD_APPROVAL) targetApprovalId = action?.response?.approvalId;

	const mapRelatedDocuments = (document) => {
		if (targetDocumentId === document?.id) {
			let newApprovals = [...(document?.approvals ?? [])];
			if (action.type === ADD_APPROVAL) newApprovals = [...newApprovals, {...action?.response}];
			if (action.type === DELETE_APPROVAL)
				newApprovals = newApprovals.filter(
					({id = null, approvalId = null}) => ![id, approvalId].includes(targetApprovalId)
				);
			return {
				...document,
				approvals: newApprovals
			};
		} else return {...document};
	};

	const mapTechnology = (technology) => {
		return {
			...technology,
			relatedDocuments: technology?.relatedDocuments?.map(mapRelatedDocuments)
		};
	};

	const newState = {
		...state,
		data: state?.data?.map(mapTechnology)
	};

	return newState;
};
